// Egen, stiligen bekräftelseruta - ersätter webbläsarens inbyggda window.confirm(),
// som alltid visar sidans adress (t.ex. "eonschema.vercel.app säger") och inte går
// att styla om. Används genom att lagra { meddelande, onBekrafta } i ett useState
// och rendera <BekraftaModal /> villkorligt.

export function BekraftaModal({ titel = 'Är du säker?', meddelande, farligKnapp = false, onBekrafta, onAvbryt }) {
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onAvbryt()}>
      <div className="modal-box" style={{ maxWidth: 360 }}>
        <div className="modal-header">
          <h3>{titel}</h3>
        </div>
        <div className="modal-body" style={{ textAlign: 'left' }}>
          <p style={{ margin: 0, fontSize: '.9rem', color: '#444', whiteSpace: 'pre-line' }}>{meddelande}</p>
        </div>
        <div className="modal-footer" style={{ display: 'flex', gap: 10 }}>
          <button className="btn btn-secondary" style={{ flex: 1 }} onClick={onAvbryt}>Avbryt</button>
          <button className={farligKnapp ? 'btn btn-danger' : 'btn btn-primary'} style={{ flex: 1 }} onClick={onBekrafta}>
            {farligKnapp ? 'Ta bort' : 'Bekräfta'}
          </button>
        </div>
      </div>
    </div>
  )
}
